import { IPCSRepository } from '@/pcs/domain/repositories/pcs.repository';

import { PCSFilter } from './pcs-filter';

export type PCSFiltersProps = {
  filters: IPCSRepository.Filters;
  onChange: (filters: IPCSRepository.Filters) => void;
};
export function FilterBar({ filters, onChange }: PCSFiltersProps) {
  function updateFilters(newFilters: Partial<IPCSRepository.Filters>) {
    onChange({ ...filters, ...newFilters });
  }

  return (
    <div className="flex flex-row gap-4">
      <div className="min-w-52 max-w-64">
        <PCSFilter
          filters={filters}
          onChange={(pcsId) => {
            updateFilters({ pcsId }); // Update siteId when pcsId changes
          }}
        />
      </div>
    </div>
  );
}
